module.exports = __webpack_public_path__ + "img/icon-android.af3b1068.svg";